type SearchIndexingTagParams = {
  isPrivateCategory: boolean;
  index: boolean | null;
  follow: boolean | null;
};

export function setSearchIndexingTag({ isPrivateCategory, index, follow }: SearchIndexingTagParams) {
  const key = `${isPrivateCategory}_${index}_${follow}`;

  // lookup table to map all the 18 combinations of isPrivateCategory_index_follow
  // including the valid null values when index or follow are left blank in Akeneo
  const searchIndexingTags: { [key: string]: string[] } = {
    'index, follow': ['true_true_true', 'false_true_true', 'false_null_null', 'false_null_true', 'false_true_null'],
    'index, nofollow': ['true_true_false', 'true_true_null', 'false_true_false', 'false_null_false'],
    'noindex, follow': ['true_false_true', 'true_null_true', 'false_false_true', 'false_false_null'],
    'noindex, nofollow': [
      'true_false_false',
      'true_null_false',
      'true_false_null',
      'true_null_null',
      'false_false_false',
    ],
  };
  // from the 4 possible tags in the lookup table, return the one that includes the key
  return Object.keys(searchIndexingTags).find((tag) => searchIndexingTags[tag].includes(key));
}
